<template>
  <div id="app">
    <Header @nav-toggle="showNav = !showNav" />
    <div class="main">
      <Navigation
        v-if="isAuthenticated"
        @navigated="showNav = false"
        :active="showNav" />
      <div class="view">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";
import Header from "@/components/Header";

export default {
  components: { Header, Navigation },
  data: function () {
    return {
      showNav: false,
    };
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters["isAuthenticated"];
    },

    title() {
      return this.$route.name;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/style/color";
@import "@/assets/style/responsive";
@import "@/assets/style/forms";
@import "@/assets/style/buttons";

html {
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--pale-grey);
}

#app {
  display: flex;
  flex-direction: column;

  .panel {
    box-shadow: 0 4px 8px 0 rgba(12, 0, 51, 0.1);
    background-color: white;
    padding: 1em;
  }

  .main {
    flex: 1;
    display: flex;
  }

  .view {
    padding-left: 289px; /* width of Navigation */
    max-width: 1440px;

    @include phone {
      padding-left: 0;
    }
    flex: 1;
  }

  .title {
    text-transform: capitalize;
    width: 100%;
    padding-top: 1em;
    padding-left: 1em;
    padding-right: 1em;
    background-color: white;

    h2 {
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
  }
}
</style>
